'use client';

import * as React from 'react';

import { isNativeApp } from '@/lib/native';

/**
 * True inside the App Store / Google Play app, false in a browser. Starts false so the server
 * and the first client render agree; the app finds out in an effect, before anything is shown.
 */
export function useIsNativeApp(): boolean {
  const [native, setNative] = React.useState(false);
  React.useEffect(() => {
    if (isNativeApp()) setNative(true);
  }, []);
  return native;
}
